import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const SubmitProject = () => {
  const [films, setFilms] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    synopsis: '',
    goal: '',
    endDate: '',
    director: '',
    associatedFilm: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Charger les films depuis le backend à l'ouverture de la page
    axios.get(`${process.env.REACT_APP_API_URL}/films`)
      .then(response => setFilms(response.data))
      .catch(error => console.error('Erreur lors du chargement des films:', error));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Soumission réelle vers l'API backend
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/submit-project`, formData);
      console.log('Projet soumis :', response.data);
      setSubmitted(true);

      // Redirection vers la page du projet après validation
      setTimeout(() => {
        navigate(`/projets/${response.data.projectId}`);
      }, 2000);
    } catch (error) {
      console.error('Erreur lors de la soumission:', error);
      alert('Erreur lors de la soumission : ' + (error.response?.data?.message || error.message));
    }
  };

  // Si aucun film n'est disponible
  if (films.length === 0) {
    return (
      <div className="container mx-auto px-4 py-12 text-center">
        <p className="text-red-600 font-medium">Aucun film trouvé. Vous devez d'abord créer un film avant de soumettre un projet.</p>
        <button 
          onClick={() => navigate('/')} 
          className="mt-6 bg-amber-500 text-white px-6 py-2 rounded-full hover:bg-amber-600 transition"
        >
          Retour à l’accueil
        </button>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-6">Soumettre un projet</h1>

      {submitted ? (
        <div className="bg-green-50 border border-green-400 text-green-800 p-6 rounded-lg">
          <p>Merci ! Votre projet a bien été soumis. Redirection en cours...</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white p-6 rounded-lg shadow-md">

          <div>
            <label className="block text-sm font-medium">Titre du projet</label>
            <input type="text" name="title" value={formData.title} onChange={handleChange}
              required className="mt-1 w-full border border-gray-300 px-4 py-2 rounded" />
          </div>

          <div>
            <label className="block text-sm font-medium">Réalisateur</label>
            <input type="text" name="director" value={formData.director} onChange={handleChange}
              required className="mt-1 w-full border border-gray-300 px-4 py-2 rounded" />
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium">Synopsis</label>
            <textarea name="synopsis" value={formData.synopsis} onChange={handleChange} rows={4}
              required className="mt-1 w-full border border-gray-300 px-4 py-2 rounded resize-none" />
          </div>

          <div>
            <label className="block text-sm font-medium">Objectif (FCFA)</label>
            <input type="number" name="goal" value={formData.goal} onChange={handleChange}
              required className="mt-1 w-full border border-gray-300 px-4 py-2 rounded" />
          </div>

          <div>
            <label className="block text-sm font-medium">Date de fin de campagne</label>
            <input type="date" name="endDate" value={formData.endDate} onChange={handleChange}
              required className="mt-1 w-full border border-gray-300 px-4 py-2 rounded" />
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium">Film associé</label>
            <select name="associatedFilm" value={formData.associatedFilm} onChange={handleChange}
              required className="mt-1 w-full border border-gray-300 px-4 py-2 rounded">
              <option value="">-- Choisir un film --</option>
              {films.map(film => (
                <option key={film.id} value={film.id}>{film.title} ({film.director})</option>
              ))}
            </select>
          </div>

          <div className="md:col-span-2 text-right">
            <button type="submit" className="bg-amber-500 text-white px-6 py-2 rounded-full hover:bg-amber-600 transition">
              Soumettre le projet
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default SubmitProject;
